import { Action } from '@ngrx/store';

export const ActionTypes = {
	LOAD_CUSTOMNOTIFICATIONS: '[Customnotifications] LOAD_CUSTOMNOTIFICATIONS',
	RESET_STATE: '[Customnotifications] RESET_STATE',
	SET_IS_LOADING: '[Customnotifications] SET_IS_LOADING'
};

export class LoadCustomNotificationsAction implements Action {
	readonly type = ActionTypes.LOAD_CUSTOMNOTIFICATIONS;
	constructor(public payload?: any) {}
}

export class SetIsLoadingAction implements Action {
	readonly type = ActionTypes.SET_IS_LOADING;
	constructor(public payload?: any) {}
}

export type Actions =
	| LoadCustomNotificationsAction
	| SetIsLoadingAction;